import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';
import { buttonCSS } from '@simplywallst/ui-core';
import type { ButtonProps } from '@simplywallst/ui-core';

export const EditNarrativeLink = styled(RouterLink)<ButtonProps>`
  ${buttonCSS}
  align-items: center;
  display: inline-flex;
  justify-content: center;
`;
